import { render, staticRenderFns } from "./MarketShow.vue?vue&type=template&id=409c82dd&scoped=true&"
import script from "./MarketShow.vue?vue&type=script&lang=js&"
export * from "./MarketShow.vue?vue&type=script&lang=js&"
import style0 from "./MarketShow.vue?vue&type=style&index=0&id=409c82dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409c82dd",
  null
  
)

export default component.exports